import { EvalIds, ProductNameType } from "graphql/generated";

export const NO_SKIP_EVAL_IDS = [
  EvalIds.AcneZoey,
  EvalIds.HairlossZoey,
  EvalIds.Hairloss,
  // EvalIds.HairlossHk,
  EvalIds.PregnancyChecklist,
  EvalIds.Therapy,
  EvalIds.SexTherapyZoey,
  EvalIds.TherapyZoey,
  EvalIds.Nutritionist
];

export const CONSULT_ONLY_TREAMENTS: EvalIds[] = [
  EvalIds.Therapy,
  EvalIds.TherapyZoey,
  EvalIds.CovidTeleconsult,
  EvalIds.Nutritionist,
  EvalIds.PregnancyChecklist,
  EvalIds.SexTherapy,
  EvalIds.SexTherapyZoey
];

export const CONSULT_ONLY_PROD_UNIQNAME: ProductNameType[] = [
  ProductNameType.FertilityCoach,
  ProductNameType.GynaeConsult,
  ProductNameType.GynaeConsultHormoneTest
];

export const NO_PICKUP_EVALUATIONS: EvalIds[] = [EvalIds.WeightLoss, EvalIds.WeightLossZoey];
